import axios from "axios";
import { getHeaders, getURl } from "./core";

const url = `${getURl()}/client/v1`;
export function getSetting(clientId = 1) {
  return axios({
    method: "GET",
    url: `${url}/setting/${clientId}`,
    headers: getHeaders()
  });
}

export function updateRecordById(id, dataToUpdate) {
  return axios({
    method: 'PUT',
    url: `${url}/update/${id}`,
    headers: getHeaders(),
    data: dataToUpdate
  });
}